module.exports = __webpack_public_path__ + "img/img.469365e4.png";